const STORE_LOCATOR_TIMINGS = {
  openingTime: "11AM",
  closingTime: "10PM",
};

const STORE_LOCATOR_LABEL = "STORE LOCATOR";

export { STORE_LOCATOR_TIMINGS, STORE_LOCATOR_LABEL };
